import * as React from "react";
import { connect } from "react-redux";
import EditProfile from "../../screens/EditProfile";

import {} from "./action";
class EditProfileContainer extends React.Component<Props, State> {
  render() {
    return <EditProfile />;
  }
}
function bindAction(dispatch) {
  return {};
}
const mapStateToProps = state => {
  return {};
};

export default connect(
  mapStateToProps,
  bindAction
)(EditProfileContainer);
